import { CreateCompanyRequestDTO } from "../../../data/models/CompanyDTOs";
import { CompanyRepository } from "../../repositories/CompanyRepository";

const ACCOUNTING_START_MONTH_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

/**
 * Create Company Use Case
 * Creates a new company with auto-admin user
 */
export class CreateCompanyUseCase {
  constructor(private repository: CompanyRepository) {}

  async execute(data: CreateCompanyRequestDTO): Promise<{
    company: any;
    admin_credentials: { email: string; password: string };
  }> {
    if (!data.company_name || !data.company_name.trim()) {
      throw new Error("Company name is required");
    }

    if (!data.app_url || !data.app_url.trim()) {
      throw new Error("Subdomain (app_url) is required");
    }

    if (data.company_gst_enabled === 1 && !data.gst_number?.trim()) {
      throw new Error("GST number is required when GST is enabled");
    }

    if (
      data.accounting_start_month &&
      !ACCOUNTING_START_MONTH_REGEX.test(data.accounting_start_month)
    ) {
      throw new Error(
        "Accounting start month must be in YYYY-MM format (e.g. 2024-04)"
      );
    }

    if (
      data.dso_lookback_months !== undefined &&
      data.dso_lookback_months < 1
    ) {
      throw new Error("DSO lookback months must be at least 1");
    }

    return await this.repository.createCompany(data);
  }
}
